import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dismissable"
export default class extends Controller {
  static targets = ["container"]
  static values = { key: String }

  connect() {
    if (localStorage.getItem(this.keyValue)) {
      this.containerTarget.classList.add("hidden")
    }
  }

  dismiss() {
    localStorage.setItem(this.keyValue, "true")
    this.containerTarget.classList.add("hidden")
  }
}
